import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _app = { entitledStartDate: 'google.protobuf.Timestamp' };
var _getSectionRequest = {};
var _getSectionResponse = { sections: '_section' };
var _section = { app: '_app' };
function resolveWixAppmarketV1MarketSectionsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-market/sections',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/sections',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/sections',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/sections',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/sections',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get a Section by placement */
export function getSection(payload) {
    var _a = serializer(_getSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSectionResponse, {
        _app: _app,
        _section: _section,
    }).fromJSON;
    function __getSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.section',
            method: 'GET',
            methodFqn: 'wix.appmarket.v1.MarketSections.GetSection',
            url: resolveWixAppmarketV1MarketSectionsUrl({
                protoPath: '/v1/sections/{placement}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSection.fromReq = fromReq;
    __getSection.__isAmbassador = true;
    return __getSection;
}
//# sourceMappingURL=http.impl.js.map